import { EVENT_PAGE_VIEW } from '../../../hooks/useTracking/events/eventTypes.js';
import { buildVirtualPath } from '../../../hooks/useTracking/utils/index.js';
export const action = payload => ({
  type: EVENT_PAGE_VIEW,
  payload
});
export const handler = action => {
  return {
    virtpath: buildVirtualPath(action.payload.page, action.payload.portal),
    event: 'page_view'
  };
};